














































































































































































































































































































import {
  perSchoolFieldOptions,
  standardFieldOptions,
} from "@/constants/automations";
import OrgSelectionAdmin from "@/components/admin/OrgSelectionAdmin.vue";
import { apiUrl } from "@/domain";
import Vue from "vue";
import VueUploadComponent from "vue-upload-component";
import NoticeMain from "@/components/NoticeMain.vue";
import { yearsToNamesShort } from "@/services/GeneralHelper";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import ApiService from "../services/ApiService";
import ImageCompressor from "compressorjs";
import { format, parse } from "fecha";
import SchoolsVue from "./Schools.vue";

export default Vue.extend({
  data() {
    return {
      category: "",
      expandInfo: false,
      showErrors: false,
      loading: false,
      imagesLoading: false,
      mainLoading: false,
      uploadUrl:
        apiUrl +
        "/api/uploadFile?notice&school_id=" +
        this.$route.params.school_id,
      counterUsers: 0,
      field: null,
      newPost: {
        type: null,
        category: null,
        user_type: null,
        title: null,
        question: null,
        message: "",
        years: [],
        answers: [{ answer: "" }, { answer: "" }],
        images: [],
        date: "",
        group: null,
        school: null,
        important: false,
        useSchoolFrontImage: false,
        sendNotification: false,
        staffOnly: false,
        allow_comments: true,
        event: false,
        transport_modes: [],
        school_years: [],
        schools: [],
        adminAudience: {},
      },
      hide: {
        table: true,
        url: true,
        strikethrough: true,
        indent: true,
        outdent: true,
      },
      previewItem: {},
      errors: [],
      files: [],
      years: [],
      rules: {},
      checkAllModes: true,
      showTravelFilter: false,
      transport_modes: [
        "Walking",
        "Cycling",
        "Car",
        "Train",
        "School Bus",
        "Public Bus",
      ],
      groups: [],
      schools: [],
    };
  },
  components: {
    "file-upload": VueUploadComponent,
    NoticeMain,
    OrgSelectionAdmin,
  },
  props: {
    isTemplate: {
      type: Boolean,
      default: false,
    },
    id: {
      type: Number,
      default: 0,
    },
  },
  validations() {
    const validations = {
      newPost: {},
    };
    if (this.newPost.event) {
      // @ts-ignore
      validations.newPost.title = {
        required,
        minLength: minLength(4),
      };
      // @ts-ignore
      validations.newPost.date = {
        required,
      };
    }
    if (this.newPost.category != "poll") {
      // @ts-ignore
      validations.newPost.message = {
        required,
        minLength: minLength(1),
      };
    } else if (this.newPost.category === "poll") {
      // @ts-ignore
      validations.newPost.message = {
        maxLength: maxLength(2000),
      };
      // @ts-ignore
      validations.newPost.title = {
        maxLength: minLength(1),
        required,
      };
      // @ts-ignore
      validations.newPost.answers = {
        $each: {
          answer: {
            required,
            maxLength: maxLength(80),
          },
        },
      };
    }
    return validations;
  },
  methods: {
    changeCategory(cat) {
      this.category = cat;
      this.newPost.category = cat;
      this.newPost.type = "NOTICE";
      if (cat === "poll") {
        this.newPost.type = "poll";
      }
    },
    convertDate(date) {
      const MM = {
        Jan: "January",
        Feb: "February",
        Mar: "March",
        Apr: "April",
        May: "May",
        Jun: "June",
        Jul: "July",
        Aug: "August",
        Sep: "September",
        Oct: "October",
        Nov: "November",
        Dec: "December",
      };

      const xx = String(new Date(date)).replace(
        /\w{3} (\w{3}) (\d{2}) (\d{4}) (\d{2}):(\d{2}):[^(]+\(([A-Z]{3})\)/,
        function ($0, $1, $2, $3, $4, $5, $6) {
          return (
            MM[$1] +
            " " +
            $2 +
            ", " +
            $3 +
            " - " +
            ($4 % 12) +
            ":" +
            $5 +
            (+$4 > 12 ? "PM" : "AM") +
            " " +
            $6
          );
        }
      );
      return xx.split("GMT")[0];
    },
    update(type) {
      if (type === "year") {
        this.newPost.group = null;
        // console.log('This year', type);
      } else if (type === "group") {
        this.newPost.school_years = [];
      }
      // ApiService.generalApi.saveNewNotice(false, this.newPost).then((resp) => {
      //   this.counterUsers = resp.data;
      // });
    },
    handleCheckAllChange() {
      if (this.newPost.transport_modes.length === 0) {
        this.checkAllModes = true;
        this.newPost.transport_modes = JSON.parse(
          JSON.stringify(this.transport_modes)
        );
      } else {
        this.checkAllModes = false;
        this.newPost.transport_modes = [];
      }
    },
    getYears() {
      ApiService.generalApi
        .getYears(this.accType, this.newPost.schools)
        .then((resp) => {
          this.years = resp;
        });
    },
    goBack() {
      if (this.isTemplate) {
        this.$emit("close");
      } else {
        this.$router.go(-1);
      }
    },
    preview() {
      this.$modal.show("preview");
      this.previewItem = JSON.parse(JSON.stringify(this.newPost));
      this.previewItem.message = this.previewItem.message.replace(
        /(?:\r\n|\r|\n)/g,
        "<br>"
      );

      this.previewItem.extras = {};
      if (this.previewItem.category === "poll") {
        this.previewItem.type = "poll";
        this.previewItem.extras.answers = this.newPost.answers;
      } else {
        this.previewItem.type = "NOTICE";
      }
      this.previewItem.from = this.$store.state.user.d;
      if (this.previewItem.school_years.length === 0) {
        this.previewItem.years = "All";
      } else {
        this.previewItem.years = yearsToNamesShort(
          this.previewItem.school_years.join(",")
        );
      }

      if (this.previewItem.images.length > 0) {
        this.previewItem.images = this.previewItem.images.map((item) => {
          return item.url;
        });
      }

      if (this.previewItem.event) {
        // console.log('Time value', this.previewItem.date);
        this.previewItem.extras.date = format(
          new Date(this.previewItem.date),
          "MMMM Do, HH:ss"
        );
      }
      // this.previewItem.from = this.$store.state.user.domain.name;
      this.previewItem.from = "CHANGE";
      const adminOrgName = this.$store.state.user.admin_organization.name;
      const adminOrgLogo = this.$store.state.user.admin_organization.logo_url;
      switch (this.accType) {
        case "ADMIN":
          this.previewItem.user_type = 5;
          this.previewItem.typeIcon = "";
          this.previewItem.typeLabel = "HomeRun Team";
          break;
        case "SCHOOL_ADMIN":
          this.previewItem.user_type = 3;
          this.previewItem.imageUrl = adminOrgLogo;
          this.previewItem.typeLabel = "School Office";
          this.previewItem.name = adminOrgName;
          break;
        case "COUNCIL_ADMIN":
          this.previewItem.user_type = 1;
          this.previewItem.imageUrl = adminOrgLogo;
          this.previewItem.typeIcon = "Council";
          this.previewItem.name = adminOrgName;
          break;
        case "MULTI_SCHOOL_ADMIN":
          this.previewItem.user_type = 1;
          this.previewItem.imageUrl = adminOrgLogo;
          this.previewItem.typeIcon = "Council";
          this.previewItem.name = adminOrgName;
          break;
      }

      this.previewItem.created_timestamp =
        Math.round(new Date().getTime() / 1000) - 20;
    },
    confirmSend() {
      this.$confirm(
        "Images are being uploaded. Are you sure you want to continue ?",
        "Confirm",
        {
          distinguishCancelAndClose: true,
          confirmButtonText: "Send anyway",
          cancelButtonText: "Go back and wait",
        }
      ).then(() => {
        this.submit();
      });
    },
    submit() {
      this.showErrors = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$message({
          showClose: true,
          message: "Please fill in all required fields",
          type: "error",
        });
        return;
      }
      if (
        this.newPost.school_years &&
        this.newPost.school_years[0] == "staffOnly"
      ) {
        this.newPost.staffOnly = true;
        this.newPost.school_years = [];
      }
      this.newPost.message = this.newPost.message.replace(
        /[\u2018\u2019]/g,
        "'"
      );
      this.$store.dispatch("loading", true);
      this.mainLoading = true;
      const payload = JSON.parse(JSON.stringify(this.newPost));
      const convertedToSchools = [];
      payload.schools.forEach((schoolId) => {
        if (typeof schoolId == "number") {
          convertedToSchools.push(schoolId);
        } else {
          if (schoolId.includes("group_")) {
            const split = schoolId.split("group_");
            const filtered = this.adminAudience.groups.filter(
              (itm) => itm.id == split[1]
            );
            if (filtered.length == 1) {
              filtered[0].school_ids.split(",").forEach((id) => {
                convertedToSchools.push(id);
              });
            }
          } else if (schoolId.includes("council_")) {
            const split = schoolId.split("council_");
            this.adminAudience.schools.forEach((itm) => {
              if (itm.council_id == split[1]) {
                convertedToSchools.push(itm.id);
              }
            });
          }
        }
      });
      payload["schools"] = convertedToSchools;

      payload.type = payload.category === "POLL" ? "POLL" : "NOTICE";
      if (payload.date) {
        payload.date = this.convertDate(payload.date);
      }

      if (this.isTemplate) {
        // it's a template
        payload.isTemplate = true;
        ApiService.generalApi
          .saveNoticeOnly(payload)
          .then((resp) => {
            this.data = resp.data;
            this.$message({
              showClose: true,
              message: "Saved",
              type: "success",
            });
            this.$emit("close");
          })
          .catch(() => {
            this.$store.dispatch("loading", false);
          });
      } else {
        ApiService.generalApi
          .saveNewNotice(true, payload)
          .then((resp) => {
            this.data = resp.data;
            this.$message({
              showClose: true,
              message: "Post published",
              type: "success",
            });
            setTimeout(() => {
              this.$router.push({ name: "Notice Board" });
            }, 100);
          })
          .catch(() => {
            this.$store.dispatch("loading", false);
          });
      }
    },
    validateTitle(rule, value, callback) {
      callback(new Error("Potatoes"));
    },
    addNewAnswer() {
      this.newPost.answers.push({ answer: "" });
    },
    removeAnswer(index) {
      if (this.newPost.answers.length > 2) {
        this.newPost.answers.splice(index, 1);
      }
    },
    removeImage(index) {
      this.newPost.images.splice(index, 1);
    },
    inputFile: function (newFile, oldFile) {
      if (newFile && oldFile && !newFile.active && oldFile.active) {
        // Get response data
        if (newFile.type.substr(0, 6) === "image/") {
          if (newFile.xhr) {
            //  Get the response status code
            const response = JSON.parse(newFile.xhr.response);
            if (response.length === 1) {
              this.newPost.images.push(response[0]);
            } else {
              return;
            }
            if (this.newPost.images.length === 10) {
              this.$notify({
                message: "Maximum of 10 images are allowed per post",
                type: "warning",
              });
            }
            setTimeout(() => {
              if (this.$refs.upload.active === false) {
                this.imagesLoading = false;
              }
            }, 500);
          }
        }
      }
      // Automatic upload
      if (
        Boolean(newFile) !== Boolean(oldFile) ||
        oldFile.error !== newFile.error
      ) {
        if (newFile.error == "") {
          this.imagesLoading = true;
          if (!this.$refs.upload.active) {
            new ImageCompressor(newFile.file, {
              quality: 0.95,
              maxHeight: 1400,
              success: (result) => {
                // Successfully deleted the error to write the new file
                this.$refs.upload.update(newFile, {
                  file: result,
                  error: "",
                  size: result.size,
                  type: result.type,
                });
                setTimeout(() => {
                  this.$refs.upload.active = true;
                }, 200);
              },
              error: (e) => {
                this.$refs.upload.update(newFile, { error: e.message });
                alert("error");
              },
            });
          }
        } else {
          if (newFile.error == 'extension') {
            this.$notify({
              message: "Unsupported file type",
              type: "warning",
            });
          }
          this.imagesLoading = false;
        }
      }
    },
    toggleModes: function () {
      this.showTravelFilter = !this.showTravelFilter;

      if (this.showTravelFilter) {
        this.newPost.transport_modes = JSON.parse(
          JSON.stringify(this.transport_modes)
        );
      } else {
        this.newPost.transport_modes = [];
      }
    },
    updateSchoolIds(updatedOrgSelection) {
      // console.log('updatedOrgSelection', updatedOrgSelection)
      this.newPost.schools = updatedOrgSelection.organization_id;
    },
    paste(e) {
      e.preventDefault();
      document.execCommand(
        "insertText",
        false,
        e.clipboardData.getData("text/plain")
      );
    },
    async copyText(mytext) {
      try {
        await navigator.clipboard.writeText(mytext);
        this.$notify.info({
          title: "Copied",
        });
      } catch ($e) {
        alert("Cannot copy");
      }
    },
  },
  computed: {
    token: function () {
      return "Bearer " + this.$store.state.token;
    },
    accType: function () {
      return this.$store.state.accType;
    },
    userId: function () {
      return parseInt(this.$store.state.user.id);
    },
    fieldOptions() {
      if (this.newPost.template_type === 2) {
        return perSchoolFieldOptions;
      } else if (this.newPost.template_type == 3) {
        return standardFieldOptions;
      } else return [];
    },
    selectedField() {
      return "%" + this.field + "%";
    },
  },
  mounted() {
    document.addEventListener("paste", this.paste);
    this.update();
    if (this.accType === "SCHOOL_ADMIN") {
      ApiService.generalApi.getSchoolGroups().then((resp) => {
        this.groups = resp.data;
      });
    }
    ApiService.generalApi.getDefaultYears().then((resp) => {
      this.years = resp.data;
    });
    if (this.accType === "SUPERADMIN") {
      ApiService.generalApi.getAdminSchools().then((resp) => {
        this.adminAudience = resp.data;
      });
    }
    if (this.id && this.id != "new" && this.isTemplate) {
      ApiService.generalApi.viewNoticeTemplate(this.id).then((resp) => {
        const data = resp.data;
        this.newPost = data;
        this.newPost.important = data.important ? true : false;
        this.newPost.allow_comments = data.allow_comments ? true : false;
        this.newPost.schools = [];
        const extras = JSON.parse(data.extras);
        if (extras.useSchoolFrontImage) {
          this.newPost.useSchoolFrontImage = true;
        }
        let message = data.message;
        if (message.substring(0, 8) == "<div><p>") {
          message = message.substring(8);
          message = message.substring(0, message.length - 10);
          this.newPost.message = message;
        }
      });
    }
  },
  beforeDestroy() {
    document.removeEventListener("paste", this.paste);
  },
});
